import React, { ReactNode } from 'react';

interface TableBodyProps {
    children: ReactNode;
}

const TableBody = ({ children }: TableBodyProps) => {
    return <div className="results__table-body">{children}</div>;
};

export default TableBody;
